import React from 'react'
import { PaymentMethodProps } from '../types'

export const FiscalYearChangeNotice = ({ paymentMethod }: PaymentMethodProps) => {
  const urlParams = new URLSearchParams(window.location.search)
  // Use <DonationFormUrl>?fake-date=2021-12-31&default_payment_method=direct_deposit for testing
  const now = urlParams.has('fake-date') ? new Date(urlParams.get('fake-date') ?? '') : new Date()
  // Remeber, in JS the first month is 0, this is December
  const isNearFiscalYearChange = now.getMonth() == 11 && now.getDate() > 26
  const needsFiscalYearChangeNotice =
    isNearFiscalYearChange && ['stripe_sepa_debit', 'direct_deposit'].includes(paymentMethod)

  if (!needsFiscalYearChangeNotice) return null
  return (
    <div className="bg-green-100 p-3 mb-3">
      {i18n.t('donate.fiscal_year_change_notice', {
        old_year: now.getFullYear(),
        new_year: now.getFullYear() + 1,
      })}
    </div>
  )
}
